import Translate from "Components/Translate";
import { WE_ARE_HERE_TO_HELP_YOU, WELCOME } from "Constant";
import useLocalStorage from "hooks/useLocalStorage";
import React from "react";
import { Col } from "reactstrap";
// import Marquee from "react-fast-marquee";

const Welcome = () => {
  const { getData } = useLocalStorage();
  const userData = getData("userData");
  const fullName = userData
    ? `${userData?.firstname} ${userData?.lastname}`
    : "";

  return (
    <Col>
      {/* <Marquee gradient={false} speed={40}> */}
      <h4 style={{ marginLeft: "10px" }}>
        <Translate>{WELCOME}</Translate>, {fullName} !
      </h4>
      {/* <p>
        <Translate>{WE_ARE_HERE_TO_HELP_YOU}</Translate>
      </p> */}
      {/* </Marquee> */}
    </Col>
  );
};

export default Welcome;
